import { useEffect, useState } from "react";
import PropTypes from "prop-types";
// @mui
import { styled } from "@mui/material/styles";
import { Box, Stack, AppBar, Toolbar, Typography } from "@mui/material";
// hooks
import useOffSetTop from "../../../hooks/useOffSetTop";
import useResponsive from "../../../hooks/useResponsive";
// utils
import cssStyles from "../../../utils/cssStyles";
// config
import { HEADER, NAVBAR } from "../../../config";
// components
import Logo from "../../../components/Logo";
import Iconify from "../../../components/Iconify";
import { IconButtonAnimate } from "../../../components/animate";
// import { getMaintenanceStatus } from "src/pages/api";
//
// import Searchbar from "./Searchbar";
import AccountPopover from "./AccountPopover";
// import LanguagePopover from "./LanguagePopover";
// import ContactsPopover from "./ContactsPopover";
// import NotificationsPopover from "./NotificationsPopover";

// ----------------------------------------------------------------------

const RootStyle = styled(AppBar, {
  shouldForwardProp: (prop) =>
    prop !== "isCollapse" && prop !== "isOffset" && prop !== "verticalLayout",
})(({ isCollapse, isOffset, verticalLayout, theme }) => ({
  ...cssStyles(theme).bgBlur(),
  boxShadow: "none",
  height: HEADER.MOBILE_HEIGHT,
  zIndex: theme.zIndex.appBar + 1,
  transition: theme.transitions.create(["width", "height"], {
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up("lg")]: {
    height: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH + 1}px)`,
    ...(isCollapse && {
      width: `calc(100% - ${NAVBAR.DASHBOARD_COLLAPSE_WIDTH}px)`,
    }),
    ...(isOffset && {
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
    }),
    ...(verticalLayout && {
      width: "100%",
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
      backgroundColor: theme.palette.background.default,
    }),
  },
}));

// ----------------------------------------------------------------------

DashboardHeader.propTypes = {
  onOpenSidebar: PropTypes.func,
  isCollapse: PropTypes.bool,
  verticalLayout: PropTypes.bool,
};

export default function DashboardHeader({
  onOpenSidebar,
  isCollapse = false,
  verticalLayout = false,
}) {
  const isOffset =
    useOffSetTop(HEADER.DASHBOARD_DESKTOP_HEIGHT) && !verticalLayout;
  // const [maintenanceMsg, setMaintenanceMsg] = useState("");
  // const [isMaintenance, setIsMaintenance] = useState(false);

  const isDesktop = useResponsive("up", "lg");

  // useEffect(() => {
  //   const controller = new AbortController();

  //   const fetchMaintenanceStatus = async () => {
  //     try {
  //       const response = await getMaintenanceStatus({
  //         signal: controller.signal,
  //       });
  //       if (response?.data?.admin?.maintenance) {
  //         setIsMaintenance(true);
  //         setMaintenanceMsg(
  //           response?.data?.admin?.message || "We’re undergoing maintenance."
  //         );
  //       } else {
  //         setIsMaintenance(false);
  //       }
  //     } catch (error) {
  //       console.error("Maintenance check failed:", error);
  //     }
  //   };

  //   fetchMaintenanceStatus();

  //   return () => controller.abort();
  // }, []);

  return (
    <RootStyle
      isCollapse={isCollapse}
      isOffset={isOffset}
      verticalLayout={verticalLayout}
    >
      <Toolbar
        sx={{
          minHeight: "100% !important",
          px: { lg: 5 },
        }}
      >
        {isDesktop && verticalLayout && <Logo sx={{ mr: 2.5 }} />}

        {!isDesktop && (
          <IconButtonAnimate
            onClick={onOpenSidebar}
            sx={{ mr: 1, color: "text.primary" }}
          >
            <Iconify icon="eva:menu-2-fill" />
          </IconButtonAnimate>
        )}

        {/* Maintenance Banner */}
        {/* {isMaintenance && (
          <Box
            className="text-center fw-bold"
            sx={{
              bgcolor: "#ffea00",
              color: "#000",
              p: 1.5,
              animation: "slide-in 1.5s ease-out, shake 3s infinite alternate",
              position: "relative",
              zIndex: 1000,
              fontSize: "1.5rem",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              boxShadow: 3,
              "@keyframes slide-in": {
                from: { transform: "translateY(-100%)" },
                to: { transform: "translateY(0)" },
              },
              "@keyframes shake": {
                "0%": { transform: "translateX(0)" },
                "25%": { transform: "translateX(-2px)" },
                "50%": { transform: "translateX(2px)" },
                "75%": { transform: "translateX(-1px)" },
                "100%": { transform: "translateX(1px)" },
              },
            }}
          >
            <span
              // className="me-2"
              style={{
                animation: "blinker 3s linear infinite",
                display: "inline-block",
              }}
            >
              🚧
            </span>
            {maintenanceMsg}
          </Box>
        )} */}
        {/* Fixed: Wrap welcome message in a container with flex properties */}
        {/* <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexGrow: 1, // Take available space
            ml: 2, // Add left margin
            color: "text.primary", // Ensure text color is set  
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            Welcome Back, Kunal Shah!
          </Typography>
        </Box> */}

        {/* <Searchbar /> */}
        <Box sx={{ flexGrow: 1 }} />  

        <Stack
          direction="row"
          alignItems="center"
          spacing={{ xs: 0.5, sm: 1.5 }}
        >
          <AccountPopover />
        </Stack>
      </Toolbar>
    </RootStyle>
  );
}
